<template>
  <Header />
  <q-page-container>
    <router-view />
  </q-page-container>
  <Footer />
</template>

<script>
import Header from './components/Header.vue';
import Footer from './components/Footer.vue';

export default {

  components: {
    Header,
    Footer,
  },

}
</script>
